"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9546],{

/***/ 77552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ algolia_card_product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/molecules/card-product/index.ts + 15 modules
var card_product = __webpack_require__(42654);
// EXTERNAL MODULE: ./lib/graphql/transformers/card-product/badge.ts
var badge = __webpack_require__(61819);
// EXTERNAL MODULE: ./lib/graphql/transformers/product/woosb.ts
var woosb = __webpack_require__(73704);
// EXTERNAL MODULE: ./lib/hooks/useBundle.ts
var useBundle = __webpack_require__(50968);
// EXTERNAL MODULE: ./lib/utils/price.ts
var price = __webpack_require__(86359);
// EXTERNAL MODULE: ./lib/utils/product.ts
var product = __webpack_require__(60597);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(20457);
// EXTERNAL MODULE: ./lib/utils/gtm/normalizeAlgoliaItem.tsx
var normalizeAlgoliaItem = __webpack_require__(23886);
;// CONCATENATED MODULE: ./components/algolia/card-product/CardProductAlgolia.tsx









var discountFormatter = function(discount) {
    if (discount.type === "percentage") return "-".concat(discount.percentage, "%");
    var _amount;
    if (discount.type === "amount") return "-".concat((0,price/* toCurrency */.j3)((_amount = discount.amount) !== null && _amount !== void 0 ? _amount : 0));
};
/**
 * CardProductAlgolia
 */ var CardProductAlgolia = function(param) {
    var hit = param.hit, _type = param.type, type = _type === void 0 ? "COMPLETE" : _type, sendEvent = param.sendEvent, itemListId = param.itemListId, itemListName = param.itemListName, itemIndex = param.itemIndex, numColumns = param.numColumns;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
    var isFalseVariable = function(hit) {
        return (0,product/* isVariable */.cG)(hit.type) && hit.variations.length === 1;
    };
    var productID = isFalseVariable(hit) ? hit.variations[0].id : hit.id;
    var isConfigurable = (0,product/* isConfigurableBundle */.CA)(hit.type, hit.woosbOptionalProducts);
    var productType = isFalseVariable(hit) ? "SIMPLE" : (0,product/* isBundle */.w_)(hit.type) && !((ref = hit.woosb_items) === null || ref === void 0 ? void 0 : ref.every(function(item) {
        return (0,product/* isSimple */.Gg)(item.type) || item.type === "variation";
    })) && !isConfigurable ? "VARIABLE" : hit.type;
    var regularPrice = hit.regular_price ? hit.regular_price : (ref1 = hit.variations[0]) === null || ref1 === void 0 ? void 0 : ref1.regular_price;
    var salePrice = hit.sale_price ? hit.sale_price : (ref2 = hit.variations[0]) === null || ref2 === void 0 ? void 0 : ref2.sale_price;
    var hasBox = (hit === null || hit === void 0 ? void 0 : (ref3 = hit.card) === null || ref3 === void 0 ? void 0 : ref3.box) && (hit === null || hit === void 0 ? void 0 : (ref4 = hit.card) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.box) === null || ref5 === void 0 ? void 0 : ref5.active);
    var imageSize = hasBox ? "small" : numColumns > 4 ? "medium" : "large";
    var onClick = function() {
        (0,helpers/* gtmPush */.De)({
            event: "select_item",
            ecommerce: {
                items: [
                    (0,normalizeAlgoliaItem/* normalizeAlgoliaItem */._)(hit, itemListId, itemListName, itemIndex)
                ]
            }
        });
    };
    var discountBundle = (0,woosb/* woosbDiscountTransformer */.m)(hit);
    // TODO: Enviar a algolia el descuento del bundle cuando depende de la cantidad
    var discount = isConfigurable ? discountFormatter(discountBundle) : "-".concat((0,price/* getPercentageDiscount */.To)(regularPrice, salePrice), "%");
    // TODO: refactorizar sin el uso del hook
    var bundle = (0,useBundle/* useBundle */.$)();
    var ref25, ref26;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_product/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: hit.path,
        type: productType,
        productID: productID,
        stock: hit.stock_status,
        hit: hit,
        sendEvent: sendEvent
    }, hasBox ? {
        box: hit === null || hit === void 0 ? void 0 : (ref6 = hit.card) === null || ref6 === void 0 ? void 0 : ref6.box
    } : {}), {
        onClick: onClick,
        isConfigurable: isConfigurable,
        editable: type === "COMPLETE"
    }), (hit === null || hit === void 0 ? void 0 : hit.seller_info) && {
        hasFreeShipping: (ref7 = hit.seller_info) === null || ref7 === void 0 ? void 0 : ref7.hasFreeShipping
    }), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Image */.Z.Image, (0,_object_spread/* default */.Z)({
                src: (ref25 = hit === null || hit === void 0 ? void 0 : (ref8 = hit.card) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.image) === null || ref9 === void 0 ? void 0 : ref9.src) !== null && ref25 !== void 0 ? ref25 : (ref10 = hit.featured_image) === null || ref10 === void 0 ? void 0 : ref10.src,
                alt: (ref26 = hit === null || hit === void 0 ? void 0 : (ref11 = hit.card) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.image) === null || ref12 === void 0 ? void 0 : ref12.alt) !== null && ref26 !== void 0 ? ref26 : (ref13 = hit.featured_image) === null || ref13 === void 0 ? void 0 : ref13.alt,
                size: imageSize
            }, (hit === null || hit === void 0 ? void 0 : (ref14 = hit.card) === null || ref14 === void 0 ? void 0 : ref14.backgroundColor) ? {
                backgroundColor: hit === null || hit === void 0 ? void 0 : (ref15 = hit.card) === null || ref15 === void 0 ? void 0 : ref15.backgroundColor
            } : {})),
            hit.primary_category && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Category */.Z.Category, {
                href: hit.primary_category.path.replace("categoria-producto/", ""),
                children: hit.primary_category.name
            }),
            (hit === null || hit === void 0 ? void 0 : (ref16 = hit.card) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.badge) === null || ref17 === void 0 ? void 0 : ref17.active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Badge */.Z.Badge, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,badge/* badgeTransformer */.k)(hit === null || hit === void 0 ? void 0 : (ref18 = hit.card) === null || ref18 === void 0 ? void 0 : ref18.badge, hit === null || hit === void 0 ? void 0 : (ref19 = hit.card) === null || ref19 === void 0 ? void 0 : ref19.life_style)), {
                children: hit.card.badge.text
            })),
            type === "COMPLETE" && hit.on_sale && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Badge */.Z.Badge, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,badge/* badgeTransformer */.k)(undefined, hit === null || hit === void 0 ? void 0 : (ref20 = hit.card) === null || ref20 === void 0 ? void 0 : ref20.life_style)), {
                children: discount
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Name */.Z.Name, {
                children: (hit === null || hit === void 0 ? void 0 : (ref21 = hit.card) === null || ref21 === void 0 ? void 0 : ref21.name) ? hit.card.name : hit.name
            }),
            hit.seller && hit.seller.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.Seller */.Z.Seller, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (hit === null || hit === void 0 ? void 0 : hit.seller_info) && ((ref22 = hit.seller_info) === null || ref22 === void 0 ? void 0 : ref22.slug) && {
                slug: hit.seller_info.slug
            }), {
                children: hit.seller[0]
            })),
            type === "COMPLETE" && hit.on_sale && !bundle && !isConfigurable && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.PriceRegular */.Z.PriceRegular, {
                children: (0,price/* toCurrency */.j3)(hit.regular_price ? hit.regular_price : (ref23 = hit.variations[0]) === null || ref23 === void 0 ? void 0 : ref23.regular_price)
            }),
            type === "COMPLETE" && !isConfigurable && /*#__PURE__*/ (0,jsx_runtime.jsx)(card_product/* default.PriceDiscounted */.Z.PriceDiscounted, {
                children: (0,price/* toCurrency */.j3)(hit.price ? bundle ? hit.regular_price : hit.price : (ref24 = hit.variations[0]) === null || ref24 === void 0 ? void 0 : ref24.price)
            })
        ]
    }));
};
CardProductAlgolia.displayName = "CardProductAlgolia";
/* harmony default export */ var card_product_CardProductAlgolia = ((/* unused pure expression or super */ null && (CardProductAlgolia)));

;// CONCATENATED MODULE: ./components/algolia/card-product/index.ts

/* harmony default export */ var algolia_card_product = (CardProductAlgolia);


/***/ }),

/***/ 21693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_link; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
;// CONCATENATED MODULE: ./components/atoms/link/Link.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        u-actions pb-1 aria-disabled:pointer-events-none aria-disabled:text-primary-200 hover:cursor-pointer\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var LinkAbstract = function(_param, ref) {
    var as = _param.as, _type = _param.type, type = _type === void 0 ? "primary" : _type, _size = _param.size, size = _size === void 0 ? "small" : _size, _className = _param.className, className = _className === void 0 ? "" : _className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "as",
        "type",
        "size",
        "className",
        "children"
    ]);
    var HTMLTag = as || "a";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,es/* oneLine */.f9)(_templateObject(), type === "primary" ? "text-primary-900  hover:text-primary-600" : "", type === "secondary" ? "text-secondary-500 hover:text-secondary-600" : "", type === "alternative" ? "text-typo-alternative hover:text-primary-900" : "", type === "current-color" ? "text-current hover:text-current" : "", type === "primary" || type === "alternative" ? "underline underline-offset-4" : "", size === "body" ? "u-body u-body--xs normal-case" : "", size === "small" ? "u-actions u-actions--link" : "", size === "large" ? "u-actions u-actions--link-large" : "", className)
    }, props), {
        children: children
    }));
};
var Link = /*#__PURE__*/ (0,react.forwardRef)(LinkAbstract);

;// CONCATENATED MODULE: ./components/atoms/link/index.ts

/* harmony default export */ var atoms_link = (Link);


/***/ }),

/***/ 21971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ GridItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var common_tags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40865);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      col-span-",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      row-span-",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * GridItem
 */ var GridItem = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _colSpanXXS = param.colSpanXXS, colSpanXXS = _colSpanXXS === void 0 ? 1 : _colSpanXXS, colSpanXS = param.colSpanXS, colSpanSM = param.colSpanSM, colSpanMD = param.colSpanMD, colSpanLG = param.colSpanLG, colSpanXL = param.colSpanXL, colSpanXXL = param.colSpanXXL, _rowSpanXXS = param.rowSpanXXS, rowSpanXXS = _rowSpanXXS === void 0 ? 1 : _rowSpanXXS, rowSpanXS = param.rowSpanXS, rowSpanSM = param.rowSpanSM, rowSpanMD = param.rowSpanMD, rowSpanLG = param.rowSpanLG, rowSpanXL = param.rowSpanXL, rowSpanXXL = param.rowSpanXXL, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_2__/* .oneLine */ .f9)(_templateObject(), colSpanXXS, colSpanXS ? "xs:col-span-".concat(colSpanXS) : "", colSpanSM ? "sm:col-span-".concat(colSpanSM) : "", colSpanMD ? "md:col-span-".concat(colSpanMD) : "", colSpanLG ? "lg:col-span-".concat(colSpanLG) : "", colSpanXL ? "xl:col-span-".concat(colSpanXL) : "", colSpanXXL ? "2xl:col-span-".concat(colSpanXXL) : "", rowSpanXXS, rowSpanXS ? "xs:row-span-".concat(rowSpanXS) : "", rowSpanSM ? "sm:row-span-".concat(rowSpanSM) : "", rowSpanMD ? "md:row-span-".concat(rowSpanMD) : "", rowSpanLG ? "lg:row-span-".concat(rowSpanLG) : "", rowSpanXL ? "xl:row-span-".concat(rowSpanXL) : "", rowSpanXXL ? "2xl:row-span-".concat(rowSpanXXL) : "", className),
        children: children
    });
};


/***/ }),

/***/ 23034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ grid; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
;// CONCATENATED MODULE: ./components/molecules/grid/Grid.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid grid-flow-row-dense  \n      ",
        "\n      grid-cols-",
        "\n      xs:grid-cols-",
        "\n      sm:grid-cols-",
        "\n      md:grid-cols-",
        "\n      lg:grid-cols-",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Grid
 */ var Grid = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, style = param.style, _outline = param.outline, outline = _outline === void 0 ? true : _outline, _xxs = param.xxs, xxs = _xxs === void 0 ? 1 : _xxs, _xs = param.xs, xs = _xs === void 0 ? 2 : _xs, _sm = param.sm, sm = _sm === void 0 ? 3 : _sm, _md = param.md, md = _md === void 0 ? 4 : _md, _lg = param.lg, lg = _lg === void 0 ? 6 : _lg, xl = param.xl, xxl = param.xxl, refProp = param.refProp, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,es/* oneLine */.f9)(_templateObject(), outline ? "gap-px *:outline *:outline-1 *:outline-primary-200" : "", xxs, xs, sm, md, lg, xl ? "xl:grid-cols-".concat(xl) : "", xxl ? "2xl:grid-cols-".concat(xxl) : "", className),
        ref: refProp,
        style: style,
        children: children
    });
};

// EXTERNAL MODULE: ./components/molecules/grid/GridItem.tsx
var GridItem = __webpack_require__(21971);
;// CONCATENATED MODULE: ./components/molecules/grid/index.ts


Grid.Item = GridItem/* GridItem */.P;
GridItem/* GridItem.displayName */.P.displayName = "Grid.Item";
/* harmony default export */ var grid = (Grid);


/***/ }),

/***/ 41139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16434);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7842);





/**
 * Breadcrumbs
 */ var Breadcrumbs = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, breadcrumbs = param.breadcrumbs, _mobileIndex = param.mobileIndex, mobileIndex = _mobileIndex === void 0 ? 1 : _mobileIndex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbJsonLd */ .gR, {
                itemListElements: [
                    {
                        position: 1,
                        name: "Inicio",
                        item: "https://d2um352p097y7m.cloudfront.net"
                    }, 
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(breadcrumbs.slice(1, breadcrumbs.length).map(function(breadcrumb, index) {
                    return {
                        position: index + 2,
                        name: breadcrumb.name,
                        item: "".concat("https://d2um352p097y7m.cloudfront.net").concat(breadcrumb.url)
                    };
                })))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "u-actions u-actions--breadcrumbs flex flex-row items-center gap-2 py-1 text-typo-primary ".concat(className),
                children: breadcrumbs.map(function(breadcrumb, index, array) {
                    var mobileVisible = array.length > 1 && index + 1 === array.length - mobileIndex;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row items-center gap-2 ".concat(!mobileVisible ? "max-lg:hidden" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_3__/* .ChevronRight */ ._, {
                                width: 12,
                                height: 12,
                                className: "shrink-0 max-lg:rotate-180 lg:hidden"
                            }),
                            breadcrumbs.length - 1 > index ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                href: breadcrumb.url,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "".concat(index + 1 === array.length ? "line-clamp-1" : "whitespace-nowrap"),
                                    children: breadcrumb.name
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "".concat(index + 1 === array.length ? "line-clamp-1" : "whitespace-nowrap"),
                                children: breadcrumb.name
                            }),
                            breadcrumbs.length - 1 > index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_3__/* .ChevronRight */ ._, {
                                width: 12,
                                height: 12,
                                className: "shrink-0 max-lg:hidden max-lg:rotate-180"
                            })
                        ]
                    }, "breadcrumb_".concat(index));
                })
            })
        ]
    });
};
Breadcrumbs.displayName = "Breadcrumbs";
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 18915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ category; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/components/InstantSearchSSRProvider.js
var InstantSearchSSRProvider = __webpack_require__(44950);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-router-nextjs/dist/es/index.js
var es = __webpack_require__(9975);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./components/algolia/instant-search/index.ts + 1 modules
var instant_search = __webpack_require__(15183);
// EXTERNAL MODULE: ./components/algolia/list-of-products/index.ts + 19 modules
var list_of_products = __webpack_require__(51159);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(82702);
;// CONCATENATED MODULE: ./components/pages/category/Category.tsx









var _NEXT_PUBLIC_ALGOLIA_SEARCH_INDEX_NAME, ref;
/**
 * Category
 */ var Category = function(_param) {
    var serverState = _param.serverState, url = _param.url, _showAlwaysFilters = _param.showAlwaysFilters, showAlwaysFilters = _showAlwaysFilters === void 0 ? false : _showAlwaysFilters, props = (0,_object_without_properties/* default */.Z)(_param, [
        "serverState",
        "url",
        "showAlwaysFilters"
    ]);
    var ref1, ref2;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(InstantSearchSSRProvider/* InstantSearchSSRProvider */.H, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, serverState), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(instant_search/* default */.Z, {
            routing: {
                router: (0,es/* createInstantSearchRouterNext */.v)({
                    singletonRouter: (router_default()),
                    serverUrl: "".concat("https://d2um352p097y7m.cloudfront.net").concat(url),
                    routerOptions: {
                        cleanUrlOnDispose: false,
                        createURL: function(param) {
                            var qsModule = param.qsModule, location = param.location, routeState = param.routeState;
                            var currentPage = location.pathname.split("/").pop();
                            var hasCurrentPage = currentPage && (0,utils/* isNumber */.hj)(currentPage);
                            var realPathName = hasCurrentPage ? location.pathname.replace("/".concat(currentPage), "") : location.pathname;
                            var queriesFromUrl = qsModule.parse(location.search.slice(1));
                            var utmQueries = Object.keys(queriesFromUrl).filter(function(key) {
                                return !Object.keys(routeState).includes(key);
                            }).reduce(function(acc, cur) {
                                acc[cur] = queriesFromUrl[cur];
                                return acc;
                            }, {});
                            var _hdrwp_product_catalog;
                            var page = ((_hdrwp_product_catalog = routeState.hdrwp_product_catalog) !== null && _hdrwp_product_catalog !== void 0 ? _hdrwp_product_catalog : {}).page;
                            var newUrl = new URL(location.href);
                            newUrl.pathname = "".concat(realPathName).concat(page && page > 1 ? "/".concat(page) : "");
                            var searchParams = new URLSearchParams(qsModule.stringify((0,_object_spread/* default */.Z)({}, routeState, utmQueries)));
                            searchParams.delete("hdrwp_product_catalog[page]");
                            newUrl.search = searchParams.toString();
                            return newUrl.toString();
                        },
                        parseURL: function(param) {
                            var qsModule = param.qsModule, location = param.location;
                            var posiblePage = location.pathname.split("/").pop();
                            var page = Number(posiblePage) || undefined;
                            var ref = qsModule.parse(location.search.slice(1)), algoliaURLData = ref.hdrwp_product_catalog;
                            return {
                                hdrwp_product_catalog: (0,_object_spread/* default */.Z)({}, algoliaURLData, page && {
                                    page: page
                                })
                            };
                        },
                        writeDelay: 400
                    }
                })
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list_of_products/* default */.Z, (0,_object_spread/* default */.Z)({
                url: url,
                type: "category",
                showFilters: serverState && ((ref = (ref2 = (ref1 = serverState.initialResults[(_NEXT_PUBLIC_ALGOLIA_SEARCH_INDEX_NAME = "hdrwp_product_catalog") !== null && _NEXT_PUBLIC_ALGOLIA_SEARCH_INDEX_NAME !== void 0 ? _NEXT_PUBLIC_ALGOLIA_SEARCH_INDEX_NAME : ""]) === null || ref1 === void 0 ? void 0 : ref1.results[0]) === null || ref2 === void 0 ? void 0 : ref2.nbHits) !== null && ref !== void 0 ? ref : 0) > 10 || showAlwaysFilters
            }, props))
        })
    }));
};
Category.displayName = "Category";

;// CONCATENATED MODULE: ./components/pages/category/index.ts

/* harmony default export */ var category = (Category);


/***/ }),

/***/ 61819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ badgeTransformer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

var ref;
var badgeTransformer = function(badge, lifeStyle) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        outline: Boolean(badge === null || badge === void 0 ? void 0 : badge.outline),
        style: (ref = badge === null || badge === void 0 ? void 0 : badge.style) !== null && ref !== void 0 ? ref : "orange"
    }, lifeStyle ? {
        roundedBottomLeft: true,
        roundedTopLeft: true
    } : {
        fullRounded: true
    });
};


/***/ }),

/***/ 73704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ woosbDiscountTransformer; }
/* harmony export */ });
/* unused harmony export woosbTransformer */
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82702);






/**
 * Function to filter an object by key or / and value
 * @param obj Object to filter
 * @param fn Function that returns true or false
 * @returns Object filtered
 */ var filterObjectEntries = function(obj, fn) {
    return obj ? Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return fn(key, value);
    })) : null;
};
/**
 * TODO: corregir el tipo de retorno
 * Function to merge two objects
 * @param a Object to merge
 * @param b Object to merge with a
 * @param fn Function to compare a and b
 * @param aKeys Array of keys to keep from a
 * @param bKeys Array of keys to keep from b
 * @returns Object merged
 */ var merge = function(a, b, fn, aKeys, bKeys) {
    return a.map(function(aItem) {
        var bItem = b.find(function(bItem) {
            return fn(aItem, bItem);
        });
        return _object_spread({}, aKeys ? filterObjectEntries(aItem, function(key) {
            return aKeys === null || aKeys === void 0 ? void 0 : aKeys.includes(key);
        }) : aItem, bKeys ? bItem && filterObjectEntries(bItem, function(key) {
            return bKeys === null || bKeys === void 0 ? void 0 : bKeys.includes(key);
        }) : bItem);
    });
};
var woosbDiscountTransformer = function(param) {
    var woosbDiscount = param.woosbDiscount, woosbDiscountAmount = param.woosbDiscountAmount;
    return {
        type: Boolean(woosbDiscountAmount) ? "amount" : Boolean(woosbDiscount) ? "percentage" : "none",
        amount: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)(woosbDiscountAmount) ? parseFloat(woosbDiscountAmount) || null : null,
        percentage: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)(woosbDiscount) ? parseFloat(woosbDiscount) || null : null
    };
};
var getDiscountByVariant = function(param) {
    var configurableQuantity = param.configurableQuantity, customQuantityDiscounts = param.customQuantityDiscounts, woosbDiscount = param.woosbDiscount, woosbDiscountAmount = param.woosbDiscountAmount;
    return configurableQuantity === null || configurableQuantity === void 0 ? void 0 : configurableQuantity.map(function(param) {
        var quantity = param.quantity;
        var customDiscount = customQuantityDiscounts === null || customQuantityDiscounts === void 0 ? void 0 : customQuantityDiscounts.find(function(d) {
            return d.size === quantity;
        });
        if (!customDiscount || (customDiscount === null || customDiscount === void 0 ? void 0 : customDiscount.typeDiscount) === "none") return _object_spread_props(_object_spread({}, woosbDiscountTransformer({
            woosbDiscount: woosbDiscount,
            woosbDiscountAmount: woosbDiscountAmount
        })), {
            quantity: quantity
        });
        var size = customDiscount.size, value = customDiscount.value, typeDiscount = customDiscount.typeDiscount;
        return {
            quantity: size,
            type: typeDiscount,
            amount: typeDiscount === "amount" ? value : null,
            percentage: typeDiscount === "percentage" ? value : null
        };
    });
};
var woosbTransformer = function(param) {
    var woosbDiscount = param.woosbDiscount, woosbDiscountAmount = param.woosbDiscountAmount, woosbLimitEachMin = param.woosbLimitEachMin, woosbLimitEachMax = param.woosbLimitEachMax, woosbLimitEachMinDefault = param.woosbLimitEachMinDefault, woosbLimitWholeMin = param.woosbLimitWholeMin, woosbLimitWholeMax = param.woosbLimitWholeMax, woosbOptionalProducts = param.woosbOptionalProducts, woosbIds = param.woosbIds, bundledItems = param.bundledItems, configurableQuantity = param.configurableQuantity, customQuantityDiscounts = param.customQuantityDiscounts;
    var discountByVariant = getDiscountByVariant({
        configurableQuantity: configurableQuantity,
        customQuantityDiscounts: customQuantityDiscounts,
        woosbDiscount: woosbDiscount,
        woosbDiscountAmount: woosbDiscountAmount
    });
    var discount = discountByVariant === null || discountByVariant === void 0 ? void 0 : discountByVariant.at(0);
    var ref, ref1, ref2, ref3;
    return {
        variants: (ref = configurableQuantity === null || configurableQuantity === void 0 ? void 0 : configurableQuantity.map(function(param) {
            var quantity = param.quantity;
            return {
                quantity: quantity
            };
        })) !== null && ref !== void 0 ? ref : [],
        discount: {
            amount: (ref1 = discount === null || discount === void 0 ? void 0 : discount.amount) !== null && ref1 !== void 0 ? ref1 : null,
            percentage: (ref2 = discount === null || discount === void 0 ? void 0 : discount.percentage) !== null && ref2 !== void 0 ? ref2 : null,
            type: (ref3 = discount === null || discount === void 0 ? void 0 : discount.type) !== null && ref3 !== void 0 ? ref3 : "none"
        },
        discountByVariant: discountByVariant,
        limitEach: {
            min: isNumber(woosbLimitEachMin) ? parseFloat(woosbLimitEachMin) : null,
            max: isNumber(woosbLimitEachMax) ? parseFloat(woosbLimitEachMax) : null,
            active: isOn(woosbLimitEachMinDefault)
        },
        limitWhole: {
            min: isNumber(woosbLimitWholeMin) ? parseFloat(woosbLimitWholeMin) : null,
            max: isNumber(woosbLimitWholeMax) ? parseFloat(woosbLimitWholeMax) : null
        },
        optionalProducts: isOn(woosbOptionalProducts),
        products: Array.isArray(woosbIds) && Array.isArray(bundledItems) ? merge(bundledItems, woosbIds, function(a, b) {
            return (a === null || a === void 0 ? void 0 : a.databaseId) === b.id;
        }, [
            "name",
            "uri",
            "primaryCategory",
            "sku",
            "type",
            "image",
            "regularPrice",
            "price",
            "onSale",
            "stockStatus",
            "stockQuantity",
            "caracteriSticasDelProducto", 
        ], [
            "id",
            "quantity"
        ])// TODO: ELIMINAR CUANDO HAYA SOPORTE PARA PRODUCTOS QUE NO SEAN SIMPLES
        .filter(function(p) {
            return isSimple(p.type);
        }).map(function(_param) {
            var caracteriSticasDelProducto = _param.caracteriSticasDelProducto, _primaryCategory = _param.primaryCategory, name = _primaryCategory.name, path = _primaryCategory.path, product = _object_without_properties(_param, [
                "caracteriSticasDelProducto",
                "primaryCategory"
            ]);
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
            var price = (ref1 = (ref = product.price) === null || ref === void 0 ? void 0 : ref.split("-")) === null || ref1 === void 0 ? void 0 : ref1[0];
            var regularPrice = (ref3 = (ref2 = product.regularPrice) === null || ref2 === void 0 ? void 0 : ref2.split("-")) === null || ref3 === void 0 ? void 0 : ref3[0];
            if (!price) {
                throw new Error("No price found, file: woosb.ts, product: ".concat(product));
            }
            if (!regularPrice) {
                throw new Error("No regularPrice found, file: woosb.ts, product: ".concat(product));
            }
            var ref11;
            return _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, product), {
                primaryCategory: {
                    name: name,
                    path: path
                },
                brand: (ref11 = (ref6 = caracteriSticasDelProducto === null || caracteriSticasDelProducto === void 0 ? void 0 : (ref4 = caracteriSticasDelProducto.datosDeProducto) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.marca) === null || ref5 === void 0 ? void 0 : ref5.at(0)) === null || ref6 === void 0 ? void 0 : ref6.slug) !== null && ref11 !== void 0 ? ref11 : "",
                image: {
                    src: ((ref7 = caracteriSticasDelProducto === null || caracteriSticasDelProducto === void 0 ? void 0 : caracteriSticasDelProducto.card.image) === null || ref7 === void 0 ? void 0 : ref7.sourceUrl) || ((ref8 = product.image) === null || ref8 === void 0 ? void 0 : ref8.sourceUrl) || FallBackIMG.src,
                    alt: ((ref9 = caracteriSticasDelProducto === null || caracteriSticasDelProducto === void 0 ? void 0 : caracteriSticasDelProducto.card.image) === null || ref9 === void 0 ? void 0 : ref9.altText) || ((ref10 = product.image) === null || ref10 === void 0 ? void 0 : ref10.altText) || product.name
                },
                price: toCurrency(price)
            }), product.onSale && {
                regularPrice: toCurrency(regularPrice)
            }), {
                uri: getRealURL(product.uri)
            });
        }) : []
    };
};


/***/ }),

/***/ 23886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ normalizeAlgoliaItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _orders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11607);
/* harmony import */ var _price__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86359);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82702);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20457);







var normalizeAlgoliaItem = function(item, itemListId, itemListName, index) {
    var ref, ref1, ref2;
    var regularPrice = item.regular_price;
    var salePrice = item.sale_price;
    var sku = item.sku;
    if (item.variations.length > 0) {
        regularPrice = item.variations[0].regular_price;
        salePrice = item.variations[0].sale_price;
        sku = !item.sku ? item.variations[0].sku : item.sku;
    }
    var discount = item.on_sale ? Number.parseFloat((0,_price__WEBPACK_IMPORTED_MODULE_0__/* .getDiscountAmount */ .TC)(regularPrice, salePrice).toFixed(2)) : null;
    var ref3;
    // TODO: cuando se implmente el buy box esto no servirá porque puede haber varios sellers
    var seller = (item === null || item === void 0 ? void 0 : (ref = item.seller) === null || ref === void 0 ? void 0 : ref.at(0)) !== _orders__WEBPACK_IMPORTED_MODULE_1__/* .OPERATOR */ .Nv ? (ref3 = item === null || item === void 0 ? void 0 : (ref1 = item.seller) === null || ref1 === void 0 ? void 0 : ref1.at(0)) !== null && ref3 !== void 0 ? ref3 : null : _helpers__WEBPACK_IMPORTED_MODULE_2__/* .AFFILIATION_NAME_OPERATOR */ .lZ;
    var ref4;
    var itemToAdd = {
        item_id: sku,
        item_name: item.name,
        // TODO: cuando se implmente el buy box esto no servirá porque puede haber varios sellers
        affiliation: seller,
        coupon: null,
        currency: "EUR",
        discount: discount,
        index: index !== null && index !== void 0 ? index : null,
        item_brand: Array.isArray(item === null || item === void 0 ? void 0 : item.marca) ? item.marca[0] : null,
        item_list_id: itemListId !== undefined ? itemListId : null,
        item_list_name: itemListName !== undefined ? itemListName : null,
        item_variant: null,
        price: regularPrice,
        quantity: 1,
        image: (ref4 = (ref2 = item.featured_image) === null || ref2 === void 0 ? void 0 : ref2.src) !== null && ref4 !== void 0 ? ref4 : null,
        url: (item === null || item === void 0 ? void 0 : item.path) ? (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getRealURL */ .U2)(item.path) : null
    };
    if (item.tags.length > 0) {
        var categories = {};
        for(var i = 0; i < item.tags.length; ++i){
            var catLabel = i === 0 ? "item_category" : "item_category".concat(i + 1);
            categories = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, categories), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, catLabel, item.tags[i].name));
        }
        itemToAdd = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, itemToAdd, categories);
    }
    return itemToAdd;
};


/***/ }),

/***/ 90451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ normalizeAlgoliaItems; }
/* harmony export */ });
/* harmony import */ var _normalizeAlgoliaItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23886);

var normalizeAlgoliaItems = function(items, itemListId, itemListName) {
    return items.map(function(item, index) {
        return (0,_normalizeAlgoliaItem__WEBPACK_IMPORTED_MODULE_0__/* .normalizeAlgoliaItem */ ._)(item, itemListId, itemListName, index);
    });
};


/***/ }),

/***/ 25892:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _wrapNativeSuper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
var _set_prototype_of = __webpack_require__(44998);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,_set_prototype_of/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,_get_prototype_of/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,_set_prototype_of/* default */.Z)(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}


/***/ }),

/***/ 44950:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ InstantSearchSSRProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_InstantSearchSSRContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42574);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


/**
 * Provider to pass the server state retrieved from `getServerState()` to
 * <InstantSearch>.
 */
function InstantSearchSSRProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  // This is used in `useInstantSearchApi()` to avoid creating and starting multiple instances of
  // `InstantSearch` on mount.
  var ssrSearchRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);

  // When <DynamicWidgets> is mounted, a second provider is used above the user-land
  // <InstantSearchSSRProvider> in `getServerState()`.
  // To avoid the user's provider overriding the context value with an empty object,
  // we skip this provider.
  if (Object.keys(props).length === 0) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_lib_InstantSearchSSRContext_js__WEBPACK_IMPORTED_MODULE_1__/* .InstantSearchSSRContext.Provider */ .q.Provider, {
    value: _objectSpread(_objectSpread({}, props), {}, {
      ssrSearchRef: ssrSearchRef
    })
  }, children);
}

/***/ }),

/***/ 9975:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ createInstantSearchRouterNext; }
/* harmony export */ });
/* harmony import */ var instantsearch_js_es_lib_routers_history_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76587);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function createInstantSearchRouterNext(options) {
  var _ref = options || {},
    beforePopState = _ref.beforePopState,
    singletonRouter = _ref.singletonRouter,
    serverUrl = _ref.serverUrl,
    beforeStart = _ref.beforeStart,
    beforeDispose = _ref.beforeDispose,
    routerOptions = _ref.routerOptions;
  var handler;
  var ownBeforePopState = function ownBeforePopState() {
    return true;
  };

  // If we're rendering on the server, we create a simpler router
  if (typeof window === 'undefined') {
    return (0,instantsearch_js_es_lib_routers_history_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_objectSpread({
      getLocation: function getLocation() {
        return new URL(serverUrl);
      }
    }, routerOptions));
  }

  /**
   * Marker to skip `routeChangeComplete` event when the push comes from the router itself.
   */
  var lastPushFromThis = false;
  var router = (0,instantsearch_js_es_lib_routers_history_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_objectSpread({
    start: function start(onUpdate) {
      var _singletonRouter$rout;
      if (beforeStart) {
        beforeStart(onUpdate);
      }
      var initialPathname = singletonRouter.pathname;
      handler = function handler() {
        // Without this check, we would trigger an unnecessary search when navigating
        // to a page without InstantSearch
        if (singletonRouter.pathname === initialPathname && !lastPushFromThis) {
          onUpdate();
        }
        lastPushFromThis = false;
      };
      singletonRouter.events.on('routeChangeComplete', handler);
      if ((_singletonRouter$rout = singletonRouter.router) !== null && _singletonRouter$rout !== void 0 && _singletonRouter$rout._bps) {
        ownBeforePopState = singletonRouter.router._bps;
      }
      function libraryBeforePopState() {
        var previousPathname = singletonRouter.asPath.split('?')[0];
        var nextPathname = new URL(window.location.href).pathname;

        // We strip the locale from the pathname if it's present
        if (singletonRouter.locale) {
          nextPathname = nextPathname.replace(previousPathname === '/' ? singletonRouter.locale : "/".concat(singletonRouter.locale), '');
        }

        // We only want to trigger a server request when going back/forward to a different page
        return previousPathname !== nextPathname;
      }
      singletonRouter.beforePopState(function (state) {
        if (beforePopState) {
          return beforePopState({
            state: state,
            libraryBeforePopState: libraryBeforePopState,
            ownBeforePopState: ownBeforePopState
          });
        }
        return libraryBeforePopState();
      });
    },
    dispose: function dispose() {
      if (beforeDispose) {
        beforeDispose();
      }
      singletonRouter.events.off('routeChangeComplete', handler);
      singletonRouter.beforePopState(ownBeforePopState);
    },
    push: function push(newUrl) {
      var url = newUrl;
      // We need to do this because there's an error when using i18n on the root path
      // it says for example `pages/fr.js` doesn't exist
      if (singletonRouter.locale) {
        url = url.replace("/".concat(singletonRouter.locale), '');
      }

      // No need to provide the second argument, Next.js will know what to do
      singletonRouter.push(url, undefined, {
        shallow: true
      });
      lastPushFromThis = true;
    }
  }, routerOptions));
  router._isNextRouter = true;
  router.$$type = 'ais.nextjs';
  return router;
}

/***/ })

}]);